import React from 'react';
import { InlineNotification } from 'carbon-components-react';
import { t } from '../RI18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorSubtitle: t('error.generic.header'),
    };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    console.log(error, info);
    // ToDo log the error to an error reporting service
    // logErrorToMyService(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <InlineNotification
          title={t('error.error')}
          subtitle={this.state.errorSubtitle}
          hideCloseButton={false}
          kind="error"
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
